__turbopack_context__.v({
  "className": "sora_4ce46268-module__kMMfUq__className",
  "variable": "sora_4ce46268-module__kMMfUq__variable",
});
